<ng-container *ngIf="(applicationStateService.isApplicationLoaded() | async) else loading">
  <ng-container *ngIf="(props$ | async) as props">
    <div class="scenario-images-container" (mousedown)="inContainerClick($event)" [class.show-more]="showMore">
      <div class="overflow-container">
        <div class="scenario-images-row">
          <div class="scenario upload">
            <label class="upload-panel" for="upload-file">
              <input id="upload-file" type="file" class="file-upload" accept="image/*" (change)="onUploadFile($event)">
              <i class="m-icon plus"></i>
              <span class="upload-text" [innerHTML]="'redesign.scenarioUpload' | translate"></span>
              <qrcode
                [qrdata]="(qrCodeService.getQrCodeLink() | async) || ''"
                [allowEmptyString]="true"
                [colorLight]="(qrCodeColorLight$ | async) || 'white'"
                [colorDark]="(qrCodeColorDark$ | async) || 'black'"
                [margin]="0"
                [imageHeight]="84"
                [width]="84"
              ></qrcode>
            </label>
          </div>
          <div class="scenario upload-preview" *ngIf="previewOfUploadedImage">
            <div class="scenario-image-container">
              <img class="scenario-image" [src]="previewOfUploadedImage" alt="" crossorigin />
              <div class="upload-indicator">
                <div class="spinner-border text-primary" style="width: 60px; height: 60px" role="status">
                </div>
              </div>
            </div>
          </div>
          <div class="scenario" *ngFor="let image of props.images">
            <div class="scenario-image-container" [class.selected]="image.id === props.selected.id">
              <img class="scenario-image" (click)="onScenarioSelected(image)" [src]="image.thumbnailUrl" alt="" crossorigin/>
              <div *ngIf="image.type === 'USER'" class="scenario-image-delete" (click)="deleteUserScenario(image)"><i class="m-icon delete"></i></div>
            </div>
          </div>
        </div>
      </div>
      <div *ngIf="showFlap" class="flap" [class.show-more]="showMore" (click)="showMore = !showMore">
        <i class="m-icon" [class.chevron-down]="!showMore" [class.chevron-up]="showMore"></i>
      </div>
    </div>
    <div class="scenarios-loading" *ngIf="showScenariosLoadingIndicator$ | async">
      <div class="spinner-border text-primary" style="width: 60px; height: 60px" role="status">
      </div>
    </div>
  </ng-container>
</ng-container>

<!-- loading indicator -->
<ng-template #loading>
  <div class="scenario-images-container loading">
    <div class="overflow-container">
      <div class="scenario-images-row">
        <div class="scenario upload">
          <div class="upload-panel loading-animation"></div>
        </div>
        <div class="scenario" *ngFor="let i of [0, 1, 2, 3, 4, 5]">
          <div class="scenario-image loading-animation">
            <div class="loading-image"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
